import call from "../../service/http";
import { SearchConstants } from "./";

export default {
  namespaced: true,
  state: {
    profile: {},
    profiles: [],
    stats: [],
    loading: false,
    skipToken: null,
    currentCursor: null,
    totalItems: 0,
    abortSignal: null,
  },
  mutations: {
    SET_PROFILE: (state, payload) => {
      state.profile = payload;
    },
    SET_PROFILES: (state, payload) => {
      state.profiles = payload;
    },
    SET_STATS: (state, payload) => {
      state.stats = payload;
    },
    SET_LOADING: (state, payload) => {
      state.loading = payload;
    },
    SET_SKIP_TOKEN: (state, payload) => {
      state.skipToken = payload;
    },
    SET_CURRENT_CURSOR: (state, payload) => {
      state.currentCursor = payload;
    },
    SET_TOTAL_ITEMS: (state, payload) => {
      state.totalItems = payload;
    },
    SET_ABORT_SIGNAL: (state, payload) => {
      state.abortSignal = payload;
    },
  },
  getters: {
    loading: (state) => state.loading,
    profile: (state) => state.profile,
    profiles: (state) => state.profiles,
    stats: (state) => state.stats,
    totalItems: (state) => state.totalItems,
    getSkipToken: (state) => state.skipToken,
    getAbortSignal: (state) => state.abortSignal,
  },
  actions: {
    getStats: (context) => {
      context.commit("SET_LOADING", true, { root: true });
      call("get", SearchConstants.stats)
        .then((res) => {
          context.commit("SET_STATS", res.data.data);
          context.commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          context.commit("SET_LOADING", false, { root: true });
          Event.$emit("toasting", {
            message: error.response.data.message,
            type: "danger",
          });
        });
    },

    search: (context, query) => {
      if (context.state.abortSignal) {
        context.state.abortSignal.abort();
      }
      const controller = new AbortController();
      const signal = controller.signal;
      context.commit("SET_ABORT_SIGNAL", signal);

      context.commit("SET_LOADING", true, { root: true });
      call("get", SearchConstants.search, null, { params: query, signal })
        .then((res) => {
          const { currentCursor, data, total, nextCursor } = res.data.data;
          context.commit("SET_SKIP_TOKEN", nextCursor);
          context.commit("SET_CURRENT_CURSOR", currentCursor);
          context.commit("SET_TOTAL_ITEMS", total);
          context.commit("SET_PROFILES", data);
          context.commit("SET_LOADING", false, { root: true });
          context.commit("SET_ABORT_SIGNAL", null);
        })
        .catch((error) => {
          context.commit("SET_ABORT_SIGNAL", null);
          context.commit("SET_LOADING", false, { root: true });
          Event.$emit("toasting", {
            message: error.response.data.message,
            type: "danger",
          });
        });
    },

    getProfile: (context, payload) => {
      context.commit("SET_LOADING", true, { root: true });
      call(
        "get",
        SearchConstants.show(payload?.profileID),
        null,
        payload ? { params: payload?.params } : {}
      )
        .then((res) => {
          context.commit("SET_PROFILE", res.data.data);
          context.commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          context.commit("SET_LOADING", false, { root: true });
          Event.$emit("toasting", {
            message: error.response.data.message,
            type: "danger",
          });
        });
    },
  },
};
